module.exports = __webpack_public_path__ + "img/2019091201.a962fdc6.png";